import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { RoundedSquareIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * 各項目のタイトル表示用コンポーネント
 * @param className
 * @param iconClassName
 * @param isBold
 * @param isShowIcon
 * @param title
 * @constructor
 */
export const RfpProfessionalOneRequiredConditionHead = ({ className = 'mb-12 sm:mb-0', iconClassName = '', isBold = true, isShowIcon = true, title, }) => (_jsxs(IconTextGroup, Object.assign({ className: className, space: 'wide' }, { children: [isShowIcon && (_jsx(RoundedSquareIcon, { className: iconClassName, color: 'base', size: 'xs' })), _jsx(Text, Object.assign({ className: 'w-[200px] lg:w-[200px] md:w-[150px]', color: 'base', isBold: isBold, size: 'sm' }, { children: title }))] })));
